// stores/wishlists.ts
import { defineStore } from 'pinia'

export const useWishlistsStore = defineStore('wishlists', {
  state: () => ({
    byId: {},
    activeFilterIds: [] // Array of wishlist IDs to filter by
  }),

  getters: {
    getById: (s) => (id) => s.byId[id],
    list: (s) => Object.values(s.byId),
    getNumOfItems: (s) => (id) => {
      const wishlist = s.byId[id]
      return wishlist ? wishlist.numberOfItems : 0
    }
  },

  actions: {
    loadAll(lists) {
      this.$reset()
      lists.forEach((list) => {
        this.byId[list.id] = list
      })
    },

    addList(wishlist) {
      this.byId[wishlist.id] = wishlist
    },

    deleteWishlist(wishlistId) {
      if (!this.byId[wishlistId]) return
      delete this.byId[wishlistId]
    },

    addItem(wishlistId, sku) {
      const wishlist = this.byId[wishlistId]
      if (!wishlist) throw new Error('Wishlist not found')

      // Check if item already exists to avoid duplicates
      const skuCode = sku.code || sku.sku || sku
      const existingItem = wishlist.items.find((item) => item.code === skuCode)

      if (!existingItem) {
        wishlist.items.push(sku)
        wishlist.numberOfItems = wishlist.items.length
      }

      wishlist.updated_at = new Date().toISOString()
    },

    removeItem(wishlistId, skuCode) {
      const wishlist = this.byId[wishlistId]
      if (!wishlist) return
      wishlist.items = wishlist.items.filter((item) => item.code !== skuCode)
      wishlist.numberOfItems = wishlist.items.length
      wishlist.updated_at = new Date().toISOString()
    },

    /** Set active filter wishlist IDs */
    setActiveFilter(wishlistIds) {
      this.activeFilterIds = Array.isArray(wishlistIds) ? [...wishlistIds] : []
    },

    /** Clear active filter */
    clearActiveFilter() {
      this.activeFilterIds = []
    },

    /** Toggle wishlist in active filter */
    toggleFilterWishlist(wishlistId) {
      const index = this.activeFilterIds.indexOf(wishlistId)
      if (index > -1) {
        this.activeFilterIds.splice(index, 1)
      } else {
        this.activeFilterIds.push(wishlistId)
      }
    },

    /** Call on logout (or automatically when customer changes) */
    resetForLogout() {
      this.$reset()
    }
  }
})
